// libs
import React from 'react';
import isEmpty from 'lodash/isEmpty';

// context
import { useDetailsContext } from 'shared/layouts/DetailsPage/Mobile/DetailsProvider/DetailsContext';

// constants
const MODEL_IMAGE_WIDTH = 40;
const DEFAULT_MODEL_ASPECT_RATIO = 0.75;

// components

import Image from 'shared/components/ImageV2';

// styles
import {
  ModelContainer,
  DetailSection,
  Title,
  DescriptionSection,
  Description,
  ImageSection,
  ImageBackdrop,
  ImageContainer,
} from './styles';

interface IModelWidget {
  modelData: {
    title: string;
    value: string;
    image_url: string;
    widget_id: string;
    widget_type: string;
    read_more: boolean;
  };
  // using aspect ratio from productMedia images as we do not get aspect ratio in model data and
  // model image is same as first image in product media
  aspectRatio: number;
  className?: string;
}

function ModelWidget({ modelData, aspectRatio, className = '' }: IModelWidget) {
  const { openImageGalleryInZoomView } = useDetailsContext();

  if (isEmpty(modelData)) {
    return null;
  }

  return (
    <ModelContainer className={className} data-at="model-section-v2">
      <ImageSection onClick={openImageGalleryInZoomView}>
        <ImageContainer>
          <Image
            src={modelData.image_url}
            width={MODEL_IMAGE_WIDTH}
            aspectRatio={aspectRatio ? aspectRatio : DEFAULT_MODEL_ASPECT_RATIO}
            animate={false}
            alt="model image"
          />
        </ImageContainer>
        <ImageBackdrop isSecond={false} />
        <ImageBackdrop isSecond={true} />
      </ImageSection>
      <DetailSection>
        <Title>{modelData.title}</Title>
        <DescriptionSection>
          <Description data-at="model-description">{modelData.value}</Description>
        </DescriptionSection>
      </DetailSection>
    </ModelContainer>
  );
}

export default ModelWidget;
